import React from 'react';
import { BoxIcon } from 'lucide-react';
interface BonusBookProps {
  icon: BoxIcon;
  number: number;
  accent: string; // tailwind text color class for the icon/accent, e.g. "text-green-400"
}
/**
 * CSS-drawn premium "book cover" mockup for a bonus, matching the
 * FUTSAL 360 dark + gold brand. No external image required.
 */
export function BonusBook({
  icon: Icon,
  number,
  accent
}: BonusBookProps) {
  return <div className="flex items-center justify-center pt-2 pb-1" data-id="element-1">
      <div className="relative w-40 aspect-[3/4] drop-shadow-2xl" data-id="element-2">
        {/* Spine */}
        <div className="absolute inset-y-0 left-0 w-3 rounded-l-lg bg-gradient-to-b from-yellow-400 to-yellow-600" data-id="element-3" />
        {/* Cover */}
        <div className="absolute inset-0 left-3 rounded-r-lg rounded-l-sm bg-slate-900 border border-slate-700 overflow-hidden flex flex-col p-4" data-id="element-4">
          {/* Icon */}
          <div className={`mb-auto ${accent}`} data-id="element-5">
            <Icon className="w-9 h-9" strokeWidth={1.75} data-id="element-6" />
          </div>
          {/* Center title */}
          <div className="text-white font-black text-xl tracking-tight leading-none" data-id="element-7">
            Bonus {number}
          </div>
          {/* Divider */}
          <div className="mt-3 mb-3 h-px w-full bg-white/20" data-id="element-8" />
          {/* Brand */}
          <div className="text-[10px] font-bold tracking-[0.2em] text-yellow-400 uppercase" data-id="element-9">
            Futsal 360™
          </div>
        </div>
      </div>
    </div>;
}